import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { DateRow, PriceRow, TextRow } from 'components';
import { renderReportTypeColor, ReportTypeEnum, Settings } from 'fragments';
import { PastOrdersCard } from './pastOrdersCard';
import { useWindowSize } from 'utils';
import { Svg } from 'assets';
import axios from 'axios';
import { NoData } from './noData';

export const PastOrders = () => {
  const [loading, setLoading] = useState(false);
  const { orders } = useSelector((state) => state.orders);
  const [width] = useWindowSize();
  const [currentId, setCurrentId] = useState('');

  const handleDownload = async (item, order) => {
    setCurrentId(order?.id);
    setLoading(true);
    try {
      const response = await axios({
        url: `/files/download`,
        method: 'POST',
        responseType: 'blob',
        data: item,
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const fileIndex = response?.data?.type?.search('/');
      const fileType = response?.data?.type?.slice(fileIndex + 1);
      let filename = item?.file?.originalName ? item?.file?.originalName : `file.${fileType === 'svg+xml' ? 'svg' : fileType}`;

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filename}`);
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } finally {
      setCurrentId('');
      setLoading(false);
    }
  };

  const handleViewPdf = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const settingsForView = (order) => [
    {
      text: 'View FRV',
      Svg: Svg.CheckSvg2,
      handleClick: () => {
        window.open(order?.frvPdfFile?.url, '_blank', 'noopener,noreferrer');
      },
    },

    {
      text: 'View FMV',
      Svg: Svg.CheckSvg2,
      handleClick: () => {
        window.open(order?.fmvPdfFile?.url, '_blank', 'noopener,noreferrer');
      },
    },
  ];

  const settingsForDownload = (order) => [
    {
      text: 'Download FRV',
      Svg: Svg.CheckSvg2,
      handleClick: async (toggleMenu) => {
        await handleDownload(order?.frvPdfFile, order);
        toggleMenu();
      },
      loadingItem: currentId === order?.id && loading,
    },

    {
      text: 'Download FMV',
      Svg: Svg.CheckSvg2,
      handleClick: async (toggleMenu) => {
        await handleDownload(order?.fmvPdfFile, order);
        toggleMenu();
      },
      loadingItem: currentId === order?.id && loading,
    },
  ];

  return (
    <div className='past-orders-wrapper'>
      {orders?.length > 0 ? (
        <div className='past-orders-block'>
          <div className='orders-page-title'>Past Orders</div>
          <div className='flex-all-center'>
            {width > 767 ? (
              <div className='past-orders-table'>
                <div className='past-orders-table-header'>
                  <div className='past-orders-table-header-row'>
                    <div className='past-orders-table-cell' style={{ width: '31%' }}>
                      <p className='past-orders-table-header-text'>Property Address</p>
                    </div>
                    <div className='past-orders-table-cell' style={{ width: '16%' }}>
                      Date Paid
                    </div>
                    <div className='past-orders-table-cell' style={{ width: '22%' }}>
                      Price
                    </div>

                    <div className='past-orders-table-cell' style={{ width: '22%' }}>
                      Type
                    </div>
                    <div className='past-orders-table-cell' style={{ width: '9%', minWidth: 100 }}>
                      Action
                    </div>
                  </div>
                </div>

                <div className='past-orders-table-body'>
                  {orders?.map((order) => (
                    <div className='past-orders-table-body-row' key={order?.id}>
                      <div className='past-orders-table-cell' style={{ width: '31%' }}>
                        <Svg.DocumentSvg />
                        <TextRow textWidth={9} color='#3D4751' name={order?.address?.formattedAddress} />
                      </div>

                      <div className='past-orders-table-cell' style={{ width: '16%' }}>
                        <DateRow color='#3D4751' date={order?.createdAt} />
                      </div>

                      <div
                        className='past-orders-table-cell'
                        style={{ width: '22%', padding: '0 4px' }}
                      >
                        <div style={{ width: '100%' }}>
                          <PriceRow info={order?.paymentAmount ? +order?.paymentAmount : 0} />

                          {order?.reportType === ReportTypeEnum.ALL &&
                            <p className='full-width' style={{ color: '#475467', fontWeight: 400 }}>
                              Bundle Saved $49
                            </p>
                          }
                        </div>
                      </div>
                      <div
                        className='past-orders-table-cell'
                        style={{ width: '22%', padding: '0 4px' }}
                      >
                        <div
                          className='past-orders-table-cell_type'
                          style={renderReportTypeColor[order?.reportType]}
                        >
                          {order?.reportType === ReportTypeEnum.ALL ? 'FRV + FMV (Bundle)' : order?.reportType}
                        </div>
                      </div>

                      <div
                        className='past-orders-table-cell'
                        style={{ width: '9%', minWidth: 100, gap: 16, padding: '0 10px' }}
                      >
                        <Settings
                          list={order?.reportType === ReportTypeEnum.ALL && settingsForView(order)}
                          onClick={() => handleViewPdf(order?.frvPdfFile?.url || order?.fmvPdfFile?.url)}

                        />
                        <Settings
                          list={order?.reportType === ReportTypeEnum.ALL && settingsForDownload(order)}
                          onClick={() => handleDownload(order?.frvPdfFile || order?.fmvPdfFile, order)}
                          MainSvg={Svg.DownloadSvg}
                          loading={loading && (currentId === order?.id) && (order?.reportType !== ReportTypeEnum.ALL)}
                          itemStyles={{ width: 159 }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className=' orders-mobile'>
                {orders?.map((order) => (
                  <PastOrdersCard
                    key={order?.id}
                    order={order}
                    handleDownload={() => handleDownload(order?.frvPdfFile || order?.fmvPdfFile, order)}
                    handleViewPdf={() => handleViewPdf(order?.frvPdfFile?.url || order?.fmvPdfFile?.url)}
                    settingsForDownload={settingsForDownload(order)}
                    settingsForView={settingsForView(order)}
                    loading={loading && (currentId === order?.id) && (order?.reportType !== ReportTypeEnum.ALL)}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      ) : (
        <NoData />
      )}
    </div>
  );
};
